module.exports = __webpack_public_path__ + "static/media/fairEthical.fd03ae62.svg";